export default {
  apiKey: process.env.AMPLITUDE_API_KEY!,
  publicApiKey: process.env.NEXT_PUBLIC_AMPLITUDE_API_KEY!,
};
